import DOMPurify from 'dompurify';

const formatBytes = (bytes) => {
    if (bytes === 0) return '0 Byte';
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
};

const getConversationAvatar = (conversation, authData) => {
    const filteredParticipants = conversation.participants.filter(
        (participant) => participant.id !== authData.id && participant.type !== authData.type
    );

    if (filteredParticipants.length === 1) {
        return filteredParticipants[0];
    } else {
        const latestAccount = conversation.latest_message?.account;
        if (latestAccount) {
            const latestAccountIndex = filteredParticipants.findIndex(
                (participant) => participant.id === latestAccount.id
            );
            if (latestAccountIndex !== -1) {
                return conversation.latest_message?.account;
            }
        }
        return filteredParticipants[0];
    }
}
const getConversationParticipants = (conversation, authData) => {
    const filteredParticipants = conversation.participants.filter(
        (participant) => participant.id !== authData.id
    );

    if (filteredParticipants.length === 1) {
        return (
            filteredParticipants[0].first_name + ' ' + filteredParticipants[0].last_name
        );
    } else {
        const latestAccount = conversation.latest_message?.account;
        if (latestAccount) {
            const latestAccountIndex = filteredParticipants.findIndex(
                (participant) => participant.id === latestAccount.id
            );

            if (latestAccountIndex !== -1) {
                filteredParticipants.splice(latestAccountIndex, 1);
                filteredParticipants.unshift(latestAccount);
            }

        }

        const participantNames = filteredParticipants.map(
            (participant) => participant.first_name
        );

        return joinParticipants(participantNames);
    }
};

function joinParticipants(participantNames) {
    const len = participantNames.length;

    if (len <= 1) {
        return participantNames.join(' and ');
    } else if (len === 2) {
        const lastTwo = participantNames.slice(len - 2).join(', ');
        return `${lastTwo} and You`;
    } else {
        const allButLastTwo = participantNames.slice(0, len - 2).join(', ');
        const lastTwo = participantNames.slice(len - 2).join(', ');
        return `${allButLastTwo}, ${lastTwo} and You`;
    }
}

function formatLinksInText(text, allowEndOfText) {

    const urlRegex = /(?:[\w.+-]+@[\w-]+(?:\.[\w-]{2,})+)|\b((https?:\/\/)?((www\.)?[\w-]+\.[\w-]{2,})(\S*))/gi;

    const newText = text.replace(urlRegex, (url, p1, p2, p3, p4, p5, offset) => {
        if (!allowEndOfText && offset + url.length === text.length) {
            return url;
        }
        let href = url;
        if (/^[\w.+-]+@/i.test(url)) {
            href = 'mailto:' + url;
        } else if (!href.startsWith('http')) {
            href = 'http://' + href;
        }
        return `<a style="color:#175cd3 !important; text-decoration: underline" href="${href}" target="_blank" >${url}</a>`;
    });

    return DOMPurify.sanitize(newText);
}

export {
    formatBytes,
    getConversationAvatar,
    getConversationParticipants,
    formatLinksInText
};
